import styled from 'styled-components';

export const Wrapper = styled.div(
  ({ theme }) => `
  border-left: ${theme.border.width.thicker}px solid ${theme.colors.interactive.border.information.default};
  border-left-color: ${theme.colors.interactive.border.information.default};
  border-radius: ${theme.border.radius.medium}px;
`
);

export const ErrorWrapper = styled.div(
  ({ theme }) => `
  border-left: ${theme.border.width.thicker}px solid ${theme.colors.interactive.border.notice.default};
  border-left-color: ${theme.colors.interactive.border.notice.default};
  border-radius: ${theme.border.radius.medium}px;
  width: 100%;
  margin-bottom: ${theme.spacing[4]}px;
`
);

export const ErrorBackground = styled.div(
  ({ theme }) => `
  background-color: ${theme.colors.feedback.background.notice.subtle};
  padding: ${theme.spacing[7]}px;
`
);
